import { Moon, Sun } from 'lucide-react';
import { FC, memo } from 'react';
import styled from 'styled-components';

import { useThemeMode } from '../../contexts/ThemeContext';

const IconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  border: none;
  background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#f1f5f9')};
  cursor: pointer;
  transition: all 0.15s ease;

  svg {
    color: ${({ theme }) => (theme.mode === 'dark' ? '#fbbf24' : '#64748b')};
    transition: color 0.15s ease;
  }

  &:hover {
    background: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#e2e8f0')};

    svg {
      color: #1a4d4d;
    }
  }
`;

interface ThemeSwitchProps {
  className?: string;
}

const ThemeSwitchComponent: FC<ThemeSwitchProps> = ({ className }) => {
  const { toggleTheme, isDarkMode } = useThemeMode();

  return (
    <IconButton
      onClick={toggleTheme}
      className={className}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      type="button"
    >
      {isDarkMode ? <Sun size={18} strokeWidth={1.5} /> : <Moon size={18} strokeWidth={1.5} />}
    </IconButton>
  );
};

export const ThemeSwitch = memo(ThemeSwitchComponent);
